<template>
  <v-container class="pa-0">
    <v-row class="ma-0">
      <v-col class="px-0 pr-5 py-0" cols="2" v-if="filtrarPorCarteiras">
            <label>Carteira</label>
            <v-select
                v-model="formData.carteira_id"
                :items="carteirasFilter"
                item-value="id"
                item-text="nome"
                :menu-props="{ bottom: true, offsetY: true }"
                flat
                solo
                dense
                outlined
                @change="resetData(false)"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="px-3 py-0">
            <label>Prestador</label>
            <v-autocomplete
              v-model="formData.prestador_id"
              :items="prestadoresFilter"
              item-value="id"
              item-text="prest_nome"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :search-input.sync="searchInput"
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'prestador_id'); updateOperadoras()" :class="formData.prestador_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.prest_nome}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.prestador_id.length>1? 'max-width:28%':'max-width:90%'">{{
              data.item.prest_nome
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.prestador_id.length == 3
                  ? formData.prestador_id.length - 2 + " outro"
                  : formData.prestador_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
      <!-- <v-col class="px-0 pr-5 py-0" cols="12" sm="6" md="3">
        <legend>Prestador</legend>
        <v-select
          v-model="formData.prestador_id"
          :menu-props="{ bottom: true, offsetY: true }"
          flat
          solo
          dense
          label="Todos"
          :items="prestadoresFilter"
          item-value="id"
          item-text="prest_nome"
          outlined
          :disabled="formData.carteira_id!=null"
          @change="updateOperadoras(formData.prestador_id)"
        ></v-select>
      </v-col>
      <v-col class="px-0 pr-5 py-0" cols="12" sm="6" md="3">
        <legend>Operadoras</legend>
        <v-select
          v-model="formData.operadora_ans_id"
          :menu-props="{ bottom: true, offsetY: true }"
          flat
          solo
          dense
          :items="operadorasFilter"
          item-value="id"
          item-text="oper_nome"
          :disabled="formData.carteira_id!=null"
          outlined
        ></v-select>
      </v-col> -->
      <v-col cols="12" sm="6" md="3" class="px-3 py-0">
            <label>Operadoras</label>
            <v-autocomplete
              v-model="formData.operadora_ans_id"
              :items="operadorasFilter"
              item-value="id"
              item-text="oper_nome"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :disabled="formData.carteira_id!=null"
              :search-input.sync="searchInput"
            >
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'operadora_ans_id')" :class="formData.operadora_ans_id.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.oper_nome}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.operadora_ans_id.length>1? 'max-width:28%':'max-width:90%'">{{
              data.item.oper_nome
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.operadora_ans_id.length == 3
                  ? formData.operadora_ans_id.length - 2 + " outro"
                  : formData.operadora_ans_id.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col class="px-0 py-5" cols="12" sm="6" md="2">
        <v-btn
          max-width="100%"
          height="30px"
          small
          color="primary"
          depressed
          class="px-3"
          @click="filter(formData)"
          >Filtrar</v-btn
        >
        <v-btn
                outlined
                small 
                height="30px"
                color="primary"
                class="px-1 ml-1"
                depressed
                @click="resetData(true)"
                >Limpar Filtro</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex'
export default {
  data() {
    return {
      formData: {
        carteira_id: null,
        grupo_economico: null,
        operadora_ans_id: [],
        prestador_id: [],
      },
      operadorasFilter:[],
      prestadoresFilter:[],
      carteirasFilter: [],
      searchInput: null
    }
  },
  computed: {
      ...mapState({
          grupoEconomico: (state) => state.permissions.grupoEconomico,
          operadoras: (state) => state.faturamento.listOperadora
      }),
      ...mapGetters({
      getPrestadoresByGeco: "permissions/getPrestadoresByGeco"
    })
  },
  watch: {
    grupoEconomico:{
      deep: true,
      handler(val) {
        this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]()
        this.formData.grupo_economico = val
        if (this.prestadoresFilter.length==1) {
          this.formData.prestador_id = [this.prestadoresFilter[0].id]
        } 
        // else if(this.prestadoresFilter.length>1) {
        //   this.prestadoresFilter.unshift({id: null, prest_nome: "Selecione"})
        // }
        if(this.filtrarPorCarteiras) {
          this.updateCarteiras()
          }
      }
    },
    operadoras:{
      deep: true,
      handler(val){
        this.operadorasFilter = Array.from(val)
        if (val.length==1) {
          this.formData.operadora_ans_id = [this.operadorasFilter[0].id]
        } 
        else {
          this.formData.operadora_ans_id =  this.formData.operadora_ans_id.filter(el => this.operadorasFilter.findIndex(item=> item.id== el)>-1 )
        }
      },
    },
    filtrarPorCarteiras:{
       deep: true,
      handler(val){
        if(val){
          this.updateCarteiras()
        }
      }
    }
  },
  mounted() {
    this.prestadoresFilter = this.$store.getters["permissions/getPrestadoresByGeco"]()
    this.formData.grupo_economico = this.grupoEconomico
    this.getOperadoras({ 
        grupoEconomico: this.grupoEconomico, 
        modulo_operadora: "recebiveis",
        prestador_ids: []
        })
    if(this.filtrarPorCarteiras) {
     this.updateCarteiras()
    }
    if (this.prestadoresFilter.length==1) {
      this.formData.prestador_id = [this.prestadoresFilter[0].id]
    } 
    if(this.nomeFiltroExterno) {
      this.$store.dispatch("recebiveis/getFilter", this.nomeFiltroExterno,  { root: true }).then(resp => { 
          let filtroExterno = resp
          if(filtroExterno){
              this.formData = Object.assign(this.formData,{...filtroExterno})
          } 
          this.filter(this.formData)
      })
    } else {
      this.filter(this.formData, true)
    }
  },
  methods: {
    ...mapActions('permissions', [
      "getOperadoras"
    ]),
    ...mapActions('recebiveis', [
      "getCarteiras"
    ]),
    resetData(all) {
        this.formData.carteira_id = all? null : this.formData.carteira_id
        this.formData.operadora_ans_id = []
        this.formData.prestador_id = this.prestadoresFilter.length==1? [this.prestadoresFilter[0].id] : []
    },
    updateCarteiras(){
       let obj = {query:[ {modulo: 'Carteira', acao: 'getcarteiras', payload: 
      {grupo_economico: this.grupoEconomico, user: true}}]}
      this.$store.dispatch("request/doRequest",obj, {root: true}).then(response => {
        if (!response || response.isAxiosError || response.erros.length) {
          this.$store.commit("hideLoader");
          return;
        }
        this.carteirasFilter = response.dados
        if(this.carteirasFilter.length) {
          this.carteirasFilter.unshift({id: null, nome: "Selecione"})
        }
      })

    },
    updateOperadoras(){
            let opts = {
                grupoEconomico: this.grupoEconomico,
                modulo_operadora: "recebiveis",
                prestador_ids: this.formData.prestador_id
            };
            this.getOperadoras(opts)
        },
        toggleAutocomplete(item, campo) {
          this.searchInput = null
          let index = this.formData[campo].indexOf(item.id)
          //  index > -1  está excluindo a operadora
          if (index > -1) {
            this.formData[campo].splice(index, 1)
          } else {
            //  index < 0  está adicionando a operadora
              this.formData[campo].push(item.id)
          }
            this.$nextTick()
            return
        },
  },
  props: {
    filter: Function,
    filtrarPorCarteiras: { type: Boolean, default: false },
    nomeFiltroExterno: {
      default: null,
      type: String
    }
  }
};
</script>
